import API from './api';

function _urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

async function _registrarSubscription(subscription) {
  const json = subscription.toJSON();
  let deviceId = null;
  try {
    deviceId = localStorage.getItem('agorax_device_id');
  } catch (e) {
    deviceId = null;
  }
  await API.post('/push/suscribir', {
    endpoint: json.endpoint,
    keys: json.keys,
    device_id: deviceId,
  });
}

// Suscribe el dispositivo a notificaciones push web (Web Push / VAPID).
// Debe llamarse SOLO cuando hay un usuario autenticado (la API requiere
// x-session-token / x-user-cedula del interceptor).
export async function setupPushNotifications() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return;
  }
  const usuarioRaw = localStorage.getItem('usuario');
  if (!usuarioRaw) {
    return;
  }

  try {
    const permiso = await Notification.requestPermission();
    if (permiso !== 'granted') {
      return;
    }

    const reg = await navigator.serviceWorker.ready;
    const { data } = await API.get('/push/vapid-public-key');
    const key = data?.data?.vapid_public_key;
    if (!key) return;

    let subscription = await reg.pushManager.getSubscription();
    if (!subscription) {
      subscription = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: _urlBase64ToUint8Array(key),
      });
    }
    await _registrarSubscription(subscription);
  } catch (e) {
    // Silencioso: la app sigue funcionando sin push.
    console.warn('No se pudo activar notificaciones push:', e);
  }
}
